import * as React from 'react';
import styled from 'styled-components'
import colors from '../../globals/colors';
import { ReactComponent as IDCard } from '../../assets/icon/id-card.svg';
import { ReactComponent as GreenCheckIcon } from '../../assets/icon/green-check-icon.svg';
import { CircularProgress } from '@mui/material'
import { uploadFile } from '../../globals/ApiHooks';
import { lang } from '../../globals/Translations';
import { TranslatedTerms } from '../../globals/TranslatedTerms';

export const DropBox = styled.div<{ filesOnHover: boolean, dropCompleted: boolean, height: number }>`
    background-color: ${p => p.dropCompleted ? colors.primaryOpacity : colors.inputOpacity};
    padding: 0px 20px;
    border-width: ${p => p.filesOnHover ? 5 : 0}px;
    border-color: ${colors.primary};
    border-style: solid;
    border-radius: 10px;
    height: ${p => p.height}px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

type Props = {
    setValue(input: string): void,
    height: number,
    value?: string | number,
    fieldName: string
}

const DragAndDrop: React.FC<Props> = ({ height, setValue, value, fieldName }) => {

    const [filesHover, setFileHover] = React.useState(false)
    const [dropCompleted, setDropCompleted] = React.useState(false)
    const inputFile = React.useRef<HTMLInputElement | null>(null)

    const [fileValue, setFileValue] = React.useState<string|number|undefined>(value)
    const [loading, setLoading] = React.useState<boolean>(false)

    const handleFileUpload = async (fileList: FileList | null) => {
        if (!fileList) return
        setLoading(true)
        const result = await uploadFile(fileList[0])
        if (result) {
            setValue(result)
            setFileValue(result)
        }
        setLoading(false)
    }

    const def = (e: React.DragEvent) => { e.preventDefault(); e.stopPropagation() }
    const handleDragEnter = (e: React.DragEvent) => { def(e); setFileHover(true) }
    const handleDragLeave = (e: React.DragEvent) => { def(e); setFileHover(false) }
    const handleDrop = (e: React.DragEvent) => {
        def(e)
        if (loading) return;
        setFileHover(false);
        setDropCompleted(true)
        handleFileUpload(e.dataTransfer.files)
    }
    const handleClick = () => !loading && inputFile?.current?.click()

    return (
        <DropBox height={height} filesOnHover={filesHover} dropCompleted={dropCompleted}
            onDrop={handleDrop} onDragOver={handleDragEnter} onDragEnter={handleDragEnter} onDragLeave={handleDragLeave} onClick={handleClick}>
            <input type='file' id='file' ref={inputFile} style={{ display: 'none' }} onChange={e => handleFileUpload(e.target.files)} />
            {!loading && !fileValue && (
                <>
                    <IDCard style={{ height: height / 3 }} />
                    <span>Drag and drop</span>
                </>
            )}
            {!loading && fileValue && (
                <>
                    <GreenCheckIcon style={{ height: height / 3 }} />
                    <span style={{textAlign:'center'}}>{lang(TranslatedTerms.FILE_FOR)} {lang(fieldName).toLowerCase()} {lang(TranslatedTerms.IS_UPLOADED).toLowerCase()} {value && "(" + fileValue + ")"}</span>
                </>
            )}
            {loading && <CircularProgress />}
        </DropBox>
    )
}

export default DragAndDrop